import { render, staticRenderFns } from "./Impressum.vue?vue&type=template&id=79772cb8&scoped=true&"
import script from "./Impressum.vue?vue&type=script&lang=js&"
export * from "./Impressum.vue?vue&type=script&lang=js&"
import style0 from "./Impressum.vue?vue&type=style&index=0&id=79772cb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79772cb8",
  null
  
)

export default component.exports